 const CropAction = ({
    service,
    image,
    isAddedImage,
    canvasWidth, 
    canvasHeight,
    cropInfo,
    canvasFormat,
    clickResetHandler,
    clickCropHandler,
    setCropDimensions, 
    setCanvasDimensions,
    setCanvasInputValue, 
    setCropValidation, 
    setCropPosition, 
    sendClickResset, 
    createImage, 
    changeImage, 
    sendClickCrop,
    dispatch,
    canvasRef
 }:{
    service: string,
    image: string,
    isAddedImage: boolean,
    canvasWidth: number, 
    canvasHeight: number,
    cropInfo: {position: {x: number, y: number}, dimensions: {width: number, height: number}},
    canvasFormat: string,
    clickResetHandler: Function,
    clickCropHandler: Function,
    setCropDimensions: Function, 
    setCanvasDimensions: Function,
    setCanvasInputValue: Function, 
    setCropValidation: Function, 
    setCropPosition: Function, 
    sendClickResset: Function, 
    createImage: Function,
    changeImage: Function, 
    sendClickCrop: Function,
    dispatch: Function,
    canvasRef: any
 }) => {
    if (service !== "cropper") return <></>;
  
    return (
      <>
        <button
          className="service__control-reset_btn btn_gray"
          onClick={() => {
            clickResetHandler(
              canvasWidth, 
              canvasHeight, 
              setCropDimensions, 
              setCanvasDimensions,
              setCanvasInputValue, 
              setCropValidation, 
              setCropPosition, 
              sendClickResset, 
              dispatch
            );
          }}
          disabled={!isAddedImage}
        >
          <span>Reset</span>
          <i className="icon__reset" />
        </button>
        <button
          className="service__control-crop_btn btn_gray"
          onClick={() => clickCropHandler(image, canvasRef, canvasWidth, canvasHeight, cropInfo.position, cropInfo.dimensions, canvasFormat, createImage, setCropValidation, changeImage, setCropDimensions, setCanvasDimensions, sendClickCrop, setCropPosition, setCanvasInputValue, setCropDimensions, dispatch)}
          disabled={!isAddedImage}
        >
          Crop
        </button>
      </>
    );
  };
  

export default CropAction;